<div *ngIf="isExternalRole">
    <app-stepper-container [isAllowedToNavigate]=false>
        <app-stepper title="1. Documents"  [isProgress]='isDocumentInProgress'>
              <app-compliancedocument (nextStepEmitter)="goNext()" ></app-compliancedocument>
        </app-stepper>
    
        <app-stepper title="2. Confirmation" [isProgress]='isConfirmationInProgress'>
            <app-complianceconfirmation (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()" style="width: 1200px;"></app-complianceconfirmation>
        </app-stepper>
    
        <app-stepper title="3. Payment" [isProgress]='isPaymentInProgress'>
            <app-compliancepayment (nextStepEmitter)="goNext()"  (prevStepEmitter)="prevStep()"></app-compliancepayment>
        </app-stepper>
    
    </app-stepper-container>
    <router-outlet></router-outlet>
</div>

